import React from 'react';

export type SelectableListContextType = {
  value: string;
  onChange: (value: string) => void;
};

export const SelectableListContext = React.createContext<SelectableListContextType>({
  value: '',
  onChange: (_value: string) => void 0,
});


export const useSelectableListContext = () => React.useContext(SelectableListContext);
